//Views
PJQ.views.payment = {};

PJQ.views.payment.PaymentModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Payment'),
		onSave: _.noop,
		minWidth: 700,
		maxWidth: 800
	},
	events: {
		'click .payment-complete': 'paymentCompleteClicked',
		'click .payment-cancel': 'paymentCancelClicked'
	},
	errors: {
		FORM_NOT_COMPLETE: 'All required fields (*) must be filled out',
		INVALID_ACCOUNT: "The card number you entered is invalid",
		DECLINED: "The card you entered was declined.  This can be due to an incorrect address, expiration date, security code, or insufficient funds.",
		ERROR: "Unable to process payment right now.  Please try again later or contact customer service."
	},
	beforeModalCreated: function () {
		if (this.options.product instanceof PJQ.models.payment.Product) {
			if (!(this.options.products instanceof PJQ.collections.payment.Products)) {
				this.options.products = new PJQ.collections.payment.Products();
			}
			this.options.products.add(this.options.product);
		}

		if (!(this.options.contact instanceof PJQ.models.contacts.Contact)) {
			this.options.contact = new PJQ.models.contacts.Contact();
		}

		if (_.size(this.options.products.models) === 0) {
			//todo: error here
		}

		this.model = new PJQ.models.payment.Transaction({
			cardholderName: this.options.contact.get('contactName'),
			address1: this.options.contact.get('address1'),
			address2: this.options.contact.get('address2'),
			city: this.options.contact.get('city'),
			state: this.options.contact.get('state'),
			zip: this.options.contact.get('zip'),
			country: _.size(this.options.contact.get('country')) > 0 ? this.options.contact.get('country') : 'US',
			cardNumber: null,
			expirationMonth: null,
			expirationYear: null,
			securityCode: null,
			products: this.options.products
		});

		if (this.options.endpoint != null) {
			this.model.endpoint = this.options.endpoint;
		}
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		};
	},
	afterRender: function () {
		new PJQ.Binder(this.$('.payment-container'), this.model, {
			watchElements: [
				'input'
			],
			afterChange: _.bind(function ($field) {
				this.validateField($field, true);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('select.payment-expiration-month'),
			hideDisabled: false,
			onChange: _.bind(function (value) {
				this.model.set('expirationMonth', value);
				this.validateField(this.$('select.payment-expiration-month'), true);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('select.payment-expiration-year'),
			hideDisabled: false,
			onChange: _.bind(function (value) {
				this.model.set('expirationYear', value);
				this.validateField(this.$('select.payment-expiration-year'), true);
			}, this)
		});

		let statePicker = new PJQ.inputs.StatePicker({
			el: this.$('select.payment-state'),
			country: this.model.get('country') ? this.model.get('country').toUpperCase() : null,
			defaultValue: this.model.get('state') ? this.model.get('state').toUpperCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('state', value);
				this.validateField(this.$('select.payment-state'), true);
			}, this)
		});

		new PJQ.inputs.CountryPicker({
			el: this.$('.payment-country'),
			defaultValue: this.model.get('country') ? this.model.get('country').toUpperCase() : null,
			statePicker: statePicker,
			zipInput: this.$('.payment-zip'),
			onChange: _.bind(function (value) {
				this.model.set('country', value);
				this.validateField(this.$('select.payment-country'), true);
			}, this)
		});
	},
	paymentCompleteClicked: function () {
		if (this.validateForm()) {
			if (this.model.endpoint != null) {
				this.$('.payment-cancel').prop('disabled', true);
				this.$('.payment-complete').prop('disabled', true).text('Processing...');
				this.model.save(null, {
					success: _.bind(function (model, response) {
						if (response.result) {
							this.removeModal();
							if (typeof this.options.onComplete === 'function') {
								this.options.onComplete(this.model);
							}
						}
						else {
							let error = response.error;
							if (_.size(error) === 0 || error === 'ERROR') {
								error = 'ERROR';
								new PJQ.logging.Debug(PJQ.logging.LoggingActions.PAYMENT_ERROR, {
									result: response,
									endpoint: (typeof this.model.endpoint === 'function') ? this.model.endpoint() : this.model.endpoint
								});
							}
							this.renderFormError(this.errors[error]);
							this.$('.payment-cancel').prop('disabled', false);
							this.$('.payment-complete').prop('disabled', false).text('Complete Order');
						}
					}, this)
				});
			}
			else {
				if (typeof this.options.onComplete === 'function') {
					this.options.onComplete(this.model);
				}
			}
		}
	},
	validateForm: function () {
		let self = this,
			isFormValid = true,
			errorFields = [];
		this.$('.payment-container').find(':required').each(function () {
			if (!self.validateField($(this))) {
				isFormValid = false;
				errorFields.push($(this).data('pBind'));
			}
		});

		if (_.size(this.$formError) > 0) {
			this.$formError.remove();
		}
		if (!isFormValid) {
			let errorText = this.errors.FORM_NOT_COMPLETE;
			if (_.size(errorFields) === 1 && errorFields.indexOf('cardNumber') !== -1) {
				errorText = this.errors.INVALID_ACCOUNT
			}
			this.renderFormError(errorText);
		}
		return isFormValid;
	},
	renderFormError: function (errorText) {
		if (_.size(this.$formError) > 0) {
			this.$formError.remove();
		}
		this.$formError = $('<div>', {
			class: 'text-danger fs-14 p-absolute left-1d25rem wd-70'
		}).text(errorText);
		this.$('.modal-footer').append(this.$formError);
	},
	validateField: function ($field, isKeyupValidation = false) {
		let attribute = $field.data('pBind'),
			value = this.model.get(attribute),
			isFieldValid = true;
		if (attribute === 'zip') {
			let zipLength = 5;
			if (_.size(this.model.get("country"))>0 && this.model.get("country").toLowerCase() === 'ca') {
				zipLength = 7;
			}
			isFieldValid = (_.size(value) === zipLength);
		}
		else if (attribute === 'cardNumber') {
			isFieldValid = PJQ.helpers.paymentHelpers.validateCreditCard(value);
		}
		else if (!value || _.size(value.toString()) === 0) {
			isFieldValid = false;
		}

		if (isFieldValid || !isKeyupValidation)
			PJQ.helpers.inputHelpers.setInputError($field, isFieldValid);

		return isFieldValid;
	},
	paymentCancelClicked: function () {
		if (typeof this.options.onCancel === 'function') {
			this.options.onCancel();
		}
	}
});

PJQ.views.payment.PaySimplePaymentModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-paysimple-payment-settings'),
		minWidth: 500,
		onSave: null,
		onError: null,
		isVerticalCenter: true
	},
	events: {
		'click .btn-save': 'save',
		'keyup .input-cardholder-name': 'cardholderNameChanged',
		'keyup .input-card-number': 'setCardIssuer'
	},
	beforeModalCreated: function () {
		PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
			this.model = billingInfo;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model == null) {
			new PJQ.Loader(this.$('.modal-content'));
			return;
		}

		new PJQ.Binder(this.$el, this.model);

		PJQ.helpers.inputHelpers.inputMaskCreditCard(this.$('.input-card-number'));

		this.monthPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-card-expiration-month'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('cardExpirationMonth', value);
			}, this)
		});

		this.yearPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-card-expiration-year'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('cardExpirationYear', value);
			}, this)
		});
	},
	cardholderNameChanged: function (e) {
		let name = $(e.currentTarget).val().trim(),
			firstName,
			lastName,
			spaceIndex = name.indexOf(' ');
		if (spaceIndex !== -1) {
			firstName = name.substr(0, spaceIndex);
			lastName = name.substr(spaceIndex + 1, _.size(name) - spaceIndex);
		}
		else {
			firstName = name;
			lastName = '';
		}
		this.model.set({
			firstName: firstName,
			lastName: lastName
		})
	},
	setCardIssuer: function () {
		let cardBrand = PJQ.helpers.paymentHelpers.getCardIssuer(this.model.get('cardNumber')),
			icon = PJQ.helpers.paymentHelpers.getCardIssuerIconFAClass(cardBrand);
		this.$('.card-issuer').addClass('fs-30 ' + icon);
	},
	validate: function () {
		let isValid = true;

		let isNameValid = _.size(this.model.get('firstName')) > 0 && _.size(this.model.get('lastName')) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-cardholder-name'), isNameValid);
		isValid = isNameValid && isValid;

		let isZipValid = _.size(this.model.get('zip').trim()) > 4;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-cardholder-zip'), isZipValid);
		isValid = isZipValid && isValid;

		let isCardValid = PJQ.helpers.paymentHelpers.validateCreditCard(this.model.get('cardNumber'));
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-card-number'), isCardValid);
		isValid = isCardValid && isValid;

		let isYearValid = (this.yearPicker.getValue() != null);
		isValid = isYearValid && isValid;
		this.$('.select-expiration-year').removeClass('p-field-error');
		if (!isYearValid) {
			this.$('.select-expiration-year').addClass('p-field-error');
		}

		let isMonthValid = (this.monthPicker.getValue() != null);
		isValid = isMonthValid && isValid;
		this.$('.select-expiration-month').removeClass('p-field-error');
		if (!isMonthValid) {
			this.$('.select-expiration-month').addClass('p-field-error');
		}

		return isValid;
	},
	saveBillingInfo: function (onSuccess, onError) {
		this.model.save(null, {
			success: _.bind(function (data) {
				if (typeof onSuccess === 'function') {
					onSuccess(this.model);
				}
			}, this),
			error: _.bind(function () {
				if (typeof onError === 'function') {
					onError(this.model);
				}
			}, this)
		});
	},
	save: function () {
		let loader = new PJQ.Loader(this.$('.modal-content'));
		if (this.validate()) {
			this.saveBillingInfo(_.bind(function () {
				if (typeof this.options.onSave === 'function') {
					this.options.onSave(this.model);
				}
				this.removeModal();
			}, this), _.bind(function () {
				if (typeof this.options.onError === 'function') {
					this.options.onError(this.model);
				}
				this.removeModal();
			}, this));
		} else {
			loader.remove();
		}
	}
});

PJQ.views.payment.SubscriptionPaymentModal = PJQ.views.payment.PaySimplePaymentModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-subscription-payment'),
		subTemplates: {
			selectSubscription: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'subscription-payment-select-subcription')
		},
		minWidth: 500,
		onSave: null,
		onError: null,
		isVerticalCenter: true,
		isShowCloseButton: true,
		selectedSubscriptionId: null
	},
	events: {
		'click .btn-save': 'save',
		'keyup .input-cardholder-name': 'cardholderNameChanged',
		'keyup .input-card-number': 'setCardIssuer',
		'click .sub-option': 'subscriptionSelected'
	},
	beforeModalCreated: function () {
		this.selectedSubscriptionId = this.options.selectedSubscriptionId > 0 ? this.options.selectedSubscriptionId : PJQ.app.session.subscription.id;
		PJQ.app.session.subscription.getCostsPerUser(_.bind(function (costs) {
			this.changeCosts = costs;
			let curCost = PJQ.app.session.subscription.get('cost');
			this.changeCosts.basic = this.changeCosts.basic - curCost;
			if(this.changeCosts.basic < 0){
				this.changeCosts.basic = 0;
			}
			this.changeCosts.pro = this.changeCosts.pro - curCost;
			if(this.changeCosts.pro < 0){
				this.changeCosts.pro = 0;
			}
			this.changeCosts.enterprise = this.changeCosts.enterprise - curCost;
			if(this.changeCosts.enterprise < 0){
				this.changeCosts.enterprise = 0;
			}

			PJQ.app.session.fetchBillingInfo(_.bind(function (billingInfo) {
				this.model = billingInfo;
				this.hasCardOnFile = this.model.get('cardNumber') != null;
				this.render();
			}, this));
		}, this));
	},
	renderData: function () {
		return {
			model: this.model,
			hasCardOnFile: this.hasCardOnFile,
			selectedSubscriptionId: this.selectedSubscriptionId,
			error: this.error
		};
	},
	afterRender: function () {
		if (this.model == null) {
			new PJQ.Loader(this.$('.modal-content'));
			return;
		}

		if (!this.hasCardOnFile) {
			new PJQ.Binder(this.$el, this.model);

			PJQ.helpers.inputHelpers.inputMaskCreditCard(this.$('.input-card-number'));

			this.monthPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-card-expiration-month'),
				noneSelectedText: '',
				defaultValue: this.model.get('cardExpirationMonth'),
				onChange: _.bind(function (value) {
					this.model.set('cardExpirationMonth', value);
				}, this)
			});

			this.yearPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-card-expiration-year'),
				noneSelectedText: '',
				defaultValue: this.model.get('cardExpirationYear'),
				onChange: _.bind(function (value) {
					this.model.set('cardExpirationYear', value);
				}, this)
			});
		}

		this.renderSelectedSubscription();
	},
	subscriptionSelected: function (e) {
		this.selectedSubscriptionId = parseInt($(e.currentTarget).data('subId'));
		this.renderSelectedSubscription();
	},
	renderSelectedSubscription: function () {
		this.renderSubTemplate(false, this.options.subTemplates.selectSubscription, this.$('.subscription-select'), {
			selectedSubscriptionId: this.selectedSubscriptionId
		});
		this.renderTotal();
	},
	renderTotal: function () {
		let cost;
		switch (this.selectedSubscriptionId) {
			case PJQ.constants.subscriptions.types.BASIC:
				cost = this.changeCosts.basic;
				break;
			case PJQ.constants.subscriptions.types.PRO:
				cost = this.changeCosts.pro;
				break;
			case PJQ.constants.subscriptions.types.ENTERPRISE:
				cost = this.changeCosts.enterprise;
				break;
			default:
				cost = 0;
				break;
		}
		this.$('.payment-total').html(PJQ.helpers.formatHelpers.formatCurrency(cost * PJQ.app.session.subscription.get('userSeats'), 2, true));
	},
	save: function () {
		let $err = this.$('.payment-error'),
			loader = new PJQ.Loader(this.$('.modal-content')),
			err = function () {
				loader.remove();
				PJQ.notifications.notify.errorNotify({
					message: 'Encountered an error upgrading your subscription.  Please contact customer service.'
				});
			};
		$err.empty();

		let cNumber = this.model.get('cardNumber');
		let fnChangeSubscription = _.bind(function () {
			PJQ.app.session.changeSubscription(this.selectedSubscriptionId, _.bind(function (data) {
				if (data == null || data.subscription == null) {
					err();
				}
				else {
					PJQ.notifications.notify.successNotify({
						message: 'Subscription successfully updated'
					});
					this.removeModal();
				}
			}, this), _.bind(function (response) {
				if (response.responseJSON != null && _.size(response.responseJSON.message) > 0) {
					this.error = response.responseJSON.message;
					if (this.hasCardOnFile) {
						this.model = new PJQ.models.billing.BillingInfo();
						this.hasCardOnFile = false;
					}
					else {
						this.model.set('cardNumber', cNumber);
					}
					this.render();
				}
				else {
					$err.html("An error occurred processing the payment.  Please contact customer service.");
					loader.remove();
					this.$('.btn-save').prop('disabled', true);
				}
			}, this));
		}, this);

		if (this.hasCardOnFile) {
			fnChangeSubscription();
		}
		else if (this.validate()) {
			this.saveBillingInfo(_.bind(function () {
				fnChangeSubscription();
			}, this), _.bind(function () {
				if (typeof this.options.onError === 'function') {
					this.options.onError(this.model);
				}
			}, this));
		}
	}
});

//Models
PJQ.models.payment = {};

PJQ.models.payment.Transaction = PJQ.models.BaseModel.extend();

PJQ.models.payment.Product = PJQ.models.BaseModel.extend();


//Collections
PJQ.collections.payment = {};

PJQ.collections.payment.Products = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.payment.Product
});
